Ext.define('SA.view.EnableGeographicUnitsOptionalSection', {
    alias: 'widget.enable-geographic-units-optional-section',
    extend: 'SA.view.SimpleContainer',

    initComponent() {
        this.items = [
            {
                xtype: 'component',

                html: [
                    '<div class="sa-enable-geographic-units-optional-section-header">',
                        'Optional ',
                        '<span class="sa-enable-geographic-units-optional-section-header-aside">',
                            '(check to enable for this project)',
                        '</span>',
                    '</div>'
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-enable-geographic-units-optional-section-list',
                items: this.getCheckboxes()
            }
        ];

        this.callParent();
    },

    getCheckboxes() {
        var allIds = this.project.getAllOptionalDiscoverableUnits(),
            enabledIds = this.project.getEnabledOptionalDiscoverableUnits();

        return SA.data.GeographicUnits.get(allIds).map(getCheckbox);

        function getCheckbox(unit) {
            return {
                xtype: 'sa-checkbox',
                boxLabel: unit.name,
                checked: enabledIds.includes(unit.id),
                cls: 'sa-enable-geographic-units-optional-section-list-item',
                unitId: unit.id
            };
        }
    },

    initEvents() {
        this.query('sa-checkbox').forEach(checkbox => {
            checkbox.on('change', this.onCheckboxChange, this);
        });
    },

    onCheckboxChange(checkbox, checked) {
        this.project.setUnitDiscoverable(checkbox.unitId, checked);
    }
});